import {
  Content,
  Page,
  Title,
} from '@monorepo/shared/componentsV2/fullPageWizard/styled/fullPageWizard';
import { Loading } from '@monorepo/shared/componentsV2/Loading';
import { useDisableSubnav } from '@monorepo/shared/hooks/subnav/useDisableSubnav';
import { useWorkflow } from '@monorepo/shared/hooks/workflows/useWorkflow';
import React from 'react';
import { useParams } from 'react-router-dom-v5-compat';
import { EditWorkflowHeader } from '../EditWorkflowHeader';
import { WorkflowOutputPreview } from '../shared/WorkflowOutputPreview';
import { WizardStep } from '../types';

export function EditWorkflowOutputPreviewPage() {
  useDisableSubnav();

  const { organizationId, workflowId } = useParams();
  const { workflow, isLoading: isWorkflowLoading } = useWorkflow({
    organizationId,
    workflowId,
  });

  if (isWorkflowLoading) {
    return (
      <Page>
        <EditWorkflowHeader wizardStep={WizardStep.OUTPUT} />
        <Loading />
      </Page>
    );
  }

  if (!workflow) {
    throw new Error("Couldn't get information about this workflow.");
  }

  return (
    <Page>
      <EditWorkflowHeader wizardStep={WizardStep.OUTPUT} />
      <Content>
        <Title>Workflow Output</Title>
        <WorkflowOutputPreview
          propertyAncestry={workflow.outputDataset.propertyAncestry}
        />
      </Content>
    </Page>
  );
}
